module.exports = "/10edfd4068d34c50b2112484a9ac70e4d00b19fd/fbca1281c2f4b02239d564167141c614.svg";